export default __webpack_public_path__ + "components/weather-icon/static/dayheavysnow-bb0c882f6ba13020bee8bd1422d026ee.svg";